import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28201172")

_pushScopeId("data-v-28201172")
const _hoisted_1 = { class: "page home-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Latest Posts", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "buttons" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "more-posts btn",
    href: "/posts/p2"
  }, " See More Posts "),
  /*#__PURE__*/_createVNode("a", {
    class: "categories btn",
    href: "/categories"
  }, " See Categories ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_post = _resolveComponent("post")!

  return (_openBlock(), _createBlock("article", _hoisted_1, [
    _createVNode(_component_post, { "hide-meta": true }),
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageData.posts, (post) => {
      return (_openBlock(), _createBlock(_component_post, {
        key: post.id,
        post: post
      }, null, 8, ["post"]))
    }), 128)),
    _hoisted_3
  ]))
})